import { Button } from '../../components/shared/Button';
import { WhatsAppIcon } from '../../components/shared/icons';

const NUMERO_WHATSAPP = import.meta.env.VITE_WHATSAPP_NEGOCIO_NUMERO as string;

export function ContactoPage() {
  return (
    <section className="px-4 sm:px-6 md:px-14 py-10 md:py-16 max-w-2xl mx-auto flex flex-col gap-6">
      <h1 className="text-4xl font-display font-semibold text-wood">Contacto</h1>
      <p className="text-[15px] leading-relaxed text-ink-muted">
        ¿Tienes una consulta antes de comprar, o buscas un pedido por volumen para tu parroquia,
        colegio o negocio? Escríbenos directamente por WhatsApp y te atendemos personalmente.
      </p>
      <a href={`https://wa.me/${NUMERO_WHATSAPP}`} target="_blank" rel="noreferrer">
        <Button>
          <WhatsAppIcon width={17} height={17} />
          Escribir por WhatsApp
        </Button>
      </a>
      <div className="text-[13px] text-ink-muted">Atendemos en todo el Perú.</div>
    </section>
  );
}
